export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7ff7ba88688c452cd8b6f7aa2522386139b65693bd&name=apiMindbox!'